import {clone, drillAndSet, drillAndMerge} from './util';

/*
WARNING genericOnChangeCreator assumes state.values and state.meta have the same shape

component: React component, usually passed in as `this` in context of React Components (required)
valuePath: the string path in state.values where the refence to the value is (required) ex: "someArray[3].field"
validator: the validation function that returns an errorMessage when invalid, or '' when valid
customMutationFunc: func to freely mutate the newState, enables things like clearing other values onChange of another
*/
export function genericOnChangeCreator(component, valuePath, validator, customMutationFunc) { // eslint-disable-line no-unused-vars
	if (typeof component.setState !== 'function') throw "The first argument to genericOnChangeCreator should be a React Component";

	return (eventOrValue) => {
		if (eventOrValue) {
			// handle cases where the component gives just a value as the onChange arg - e.g. MultiSelect component
			let val = eventOrValue.currentTarget ? eventOrValue.currentTarget.value : eventOrValue;
			let errorMessage = validator ? validator(val) : '';

			component.setState(prevState => {
				let newState = clone(prevState);

				drillAndSet(newState.values, valuePath, val);
				drillAndSet(newState.meta, `${valuePath}.errorMessage`, errorMessage);

				if (typeof customMutationFunc === 'function') customMutationFunc(newState);

				return newState;
			});
		} else {
			// clear button is clicked in datepicker component, so set date value to null
			component.setState(prevState => {
				let newState = clone(prevState);
				drillAndSet(newState.values, valuePath, null);
				return newState;
			});
		}
	};
}

export function genericOnBlurCreator(component, valuePath, validator, customMutationFunc) { // eslint-disable-line no-unused-vars
	if (typeof component.setState !== 'function') throw "The first argument to genericOnBlurCreator should be a React Component";

	return (eventOrValue) => {
		if (!eventOrValue) {
			return;
		} else {
			//handle cases where component gives just a value as the onBlur arg - e.g. MultiSelect component
			let val = eventOrValue.currentTarget ? eventOrValue.currentTarget.value : eventOrValue;
			let errorMessage = validator ? validator(val) : '';

			component.setState(prevState => {
				let newState = clone(prevState);

				drillAndMerge(newState.meta, valuePath, {
					touched: true,
					errorMessage: errorMessage
				});

				if (typeof customMutationFunc === 'function') customMutationFunc(newState);

				return newState;
			});
		}
	};
}
